<template>
  <div class="content">
    <div class="carousel_box" style="position: relative;">
      <el-carousel indicator-position="outside" height="50vw" interval="6000">
        <!-- 10.075rem -->
        <el-carousel-item>
          <img src="../../assets/newImg/lunbo1.jpg" alt="" style="width: 100%;height: 100%;" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/newImg/lunbo2.jpg" alt="" style="width: 100%;height: 100%;" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/newImg/lunbo3.jpg" alt="" style="width: 100%;height: 100%;" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <newproduct />
    <factory />
  </div>
</template>

<script>
import newproduct from './components/newproduct.vue';
import factory from './components/factory.vue'
export default {
  components:{
    newproduct,
    factory
  }
}
</script>

<style scoped>
.creatP {
  font-size: 65px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #002FA7;
  position: absolute;
  top: 210px;
  right: 385px;
}

.p1 {
  font-size: 21px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  position: absolute;
  top: 358px;
  right: 387px;
}

.moreBtn {
  background: #F7B02D;
  width: 163px;
  height: 68px;
  background: #F7B02D;
  font-size: 24px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  border: 0;
  color: #333333;
  position: absolute;
  top: 540px;
  right: 387px;
}

.bg_foot {
  position: absolute;
  bottom: 26px;
  left: 350px;
  display: flex;
}

.footBox {
  width: 417px;
  height: 102px;
  display: block;
  font-size: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  line-height: 102px;
}

 ::v-deep .el-carousel__button {
  width: .1125rem;
  height: .1125rem;
  background: #F7B02D;
  border-radius: 50%;
}
</style>
